var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    currentCountryNotEnglish: _vm.currentCountryNotEnglish,
    'my-app': true,
    isApple: _vm.isIOS
  }},[(_vm.ready)?_c('Layout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }